// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__oXixv","title":"InfoRow_title__1TA2e"};